const companieAboutReducer = (state = [], action) => {
    switch(action.type){
        case 'FETCH_COMPANIE_DATA':
            return{
                ...state,
                companie: action.payload.data
            }
        case 'CLEAR_DATA':
            return {
                ...state,
                companie: undefined
            }
        default:
            return{
                ...state
            }
    }
}
export default companieAboutReducer